import { cn } from '@/lib/utils';

import type { CollectionStats } from '../../types';

type Health = 'failed' | 'processing' | 'indexed' | 'empty';

function resolveHealth(
  c: Pick<CollectionStats, 'failed' | 'processing' | 'total_documents'>,
): Health {
  if (c.failed > 0) return 'failed';
  if (c.processing > 0) return 'processing';
  if (c.total_documents > 0) return 'indexed';
  return 'empty';
}

const STYLES: Record<Health, { dot: string; label: string }> = {
  failed: { dot: 'bg-destructive', label: 'Com falhas' },
  processing: { dot: 'bg-amber-500 animate-pulse', label: 'Processando' },
  indexed: { dot: 'bg-green-500', label: 'Indexada' },
  empty: { dot: 'bg-muted-foreground/40', label: 'Vazia' },
};

interface Props {
  collection: Pick<CollectionStats, 'failed' | 'processing' | 'total_documents'>;
}

/** Ponto de saúde da coleção — status sem depender só de cor (tem aria-label). */
export function CollectionHealthDot({ collection }: Props) {
  const health = resolveHealth(collection);
  const { dot, label } = STYLES[health];
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={cn('size-2 shrink-0 rounded-full', dot)}
    />
  );
}
